var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }